import { useState, useEffect } from "react";
import "../styles/style.css";
import "../styles/light-mode.css";

import Title from "./Title";
import Button from "./Buttons";
import ProjectCard from "./Cards/ProjectCard";
import projects from "../Data/projects.json";

import { useTranslation } from "react-i18next"

export default function SectionFour() {

    const { t } = useTranslation();

    const MOBILE_LIMIT = 3;

    const [showAll, setShowAll] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const visibleProjects =
        isMobile && !showAll
            ? projects.slice(0, MOBILE_LIMIT)
            : projects;

    return (
        <section className="section sec-4">
            <Title id="projects" title={t("title-projects.title")} />

            <h3 data-aos="fade-up"  className="container h3">{t("description-projects.text")}</h3>

            <div data-aos="fade-right" className="container container-4">
                {visibleProjects.map((project) => (
                    <ProjectCard
                        key={project.card}
                        image={project.image}
                        title={t(`projects.card${project.card}.title`)}
                        description={t(`projects.card${project.card}.description`)}
                        a={project.a}
                        div1={project.div1}
                        div2={project.div2}
                        div3={project.div3}
                    />
                ))}

                {isMobile && projects.length > MOBILE_LIMIT && (
                    <Button 
                        className="btn-click btn-view"
                        title={showAll ? t("show-less.text") : t("view-more.text")}
                        onClick={() => setShowAll(!showAll)}
                    />
                )}

            </div>
        </section>
    );
}